<template>
    <div>
        <g-media-object>
            <template #left>
                <g-typography class="g-mb-2" tag="p" font-weight="semibold" :value="title" />
                <g-typography tag="p" color="grey-6" :value="payout.brand_name" />
                <g-typography v-if="payout.resource" tag="p" color="grey-6" :value="payout.resource" />
            </template>

            <template #right>
                <g-typography v-if="isPayout" tag="p" color="grey-6">
                    <money-display :value="payout.amount" :currency="payout.currency" />
                </g-typography>
            </template>
        </g-media-object>

        <g-divider />
    </div>
</template>

<script>
    import { computed } from 'vue-demi';
    import { PAYABLE_TYPE_LABELS, PAYABLE_TYPE_CONVERSION } from '../../../../../app-v2/constants/payouts';
    import MoneyDisplay from '../../../interface/elements/MoneyDisplay.vue';

    export default {
        name: 'PayoutDetailsListItem',

        components: {
            MoneyDisplay
        },

        props: {
            payout: {
                type: Object,
                default: null
            },
            isPayout: {
                type: Boolean,
                default: false
            }
        },

        setup(props) {
            const title = computed(() => {
                return props.isPayout
                    ? PAYABLE_TYPE_LABELS[props.payout.item_type]
                    : PAYABLE_TYPE_LABELS[PAYABLE_TYPE_CONVERSION];
            });

            return {
                title
            };
        }
    };
</script>
